import { Card } from "@/components/ui/card";
import PDF from "../PDF";
import MandateForm from "./MandateForm";
import { useOrder } from "../../../contexts/OrderContext";
import React from "react";
import { ArrowRightIcon, LoaderCircleIcon, ScanTextIcon, SparklesIcon } from "lucide-react";
import MandateSelect from "./MandateSelect";
import { supabase } from "@/lib/supabase";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { OrderLoader, OrderPager } from "../Order";
import { useDocuments } from "@/contexts/DocumentsContext";
import Guide from "@/Guide";

const { APP_API_URL } = import.meta.env

export default function Mandate() {
    const { order, setOrder } = useOrder()
    const { setDocument } = useDocuments()
    const [loading, setLoading] = React.useState(false)
    const navigate = useNavigate()
    const { session } = useAuth()

    const containerRef = React.useRef(null)

    React.useEffect(() => {
        if (order?.mandate?.path) {
            setDocument(order?.mandate?.path)
        }
    }, []);

    React.useEffect(() => {
        if (!order || !!order.mandate.form) return

        const intervalId = setInterval(async () => {
            try {
                const { data, error } = await supabase
                    .from('folders')
                    .select('jsonMandate')
                    .eq('pydio_id', order.pydio_id)
                    .single()

                console.log('Fetching mandate...', order.pydio_id)

                if (data?.jsonMandate) {
                    setOrder((prevOrder) => ({
                        ...prevOrder,
                        mandate: {
                            ...order.mandate,
                            form: data.jsonMandate
                        },
                    }))
                    clearInterval(intervalId)
                }
            } catch (error) {
                console.error('Error fetching mandate:', error)
            }
        }, 5000)

        return () => clearInterval(intervalId)
    }, [order?.mandate?.mandate_storage_path, order?.pydio_id])

    // React.useEffect(() => {
    //     if (!order || !!order.sections.mandate_static) return

    //     const generateMandateHtml = async () => {
    //         await supabase.from('folders').update({ jsonMandateReviewed: order.mandate.form }).eq('pydio_id', order.pydio_id)
    
    //         const { data } = await fetch(`${APP_API_URL}/generation/section/${order.pydio_id}`, {
    //             method: "POST",
    //             headers: {
    //                 Authorization: `Bearer ${session.access_token}`,
    //             },
    //             body: JSON.stringify({
    //                 sections: ["mandate_static"]
    //             }),
    //         }).then(res => res.json())
    
    //         setOrder({
    //             ...order,
    //             sections: {
    //                 ...order.sections,
    //                 ...data
    //             }
    //         })
    //     }

    //     if (order.mandate.form) {
    //         generateMandateHtml()
    //     }
    // }, [order.mandate.form])

    const disabled = !!order.finished_at

    return <>
        <Card className="h-full w-full flex-grow min-h-0 overflow-auto" ref={containerRef}>
            <Guide step="mandate" />

            {!order.mandate.form && <OrderLoader icon={ScanTextIcon} text="Analyse du mandat" />}
            {!!order.mandate.form && <MandateForm containerRef={containerRef} disabled={disabled} />}

            {/* {!order.sections.mandate_static && <OrderLoader icon={ScanTextIcon} text="Analyse du mandat" />}
            {!!order.sections.mandate_static && <MandateForm containerRef={containerRef} disabled={disabled} />} */}
        </Card>
    </>
}